(function () {
    'use strict';

    if (window.__ERROR_COLLECTOR_INSTALLED__) return;
    window.__ERROR_COLLECTOR_INSTALLED__ = true;

    // 爬虫检测：爬虫产生的错误没有价值，直接跳过
    var ua = navigator.userAgent || '';
    if (/bot|crawl|spider|slurp|bingpreview|mediapartners|facebookexternalhit|bytespider|semrush|ahrefs|mj12bot|dotbot|petalbot|yandex|baidu|sogou|360spider|headlesschrome|phantomjs|puppet/i.test(ua)) return;

    const _fetch = window.fetch;

    // 配置
    const API_URL = 'https://app.tenways.com/api/error-log/batch';
    const BATCH_SIZE = 5;
    const BATCH_INTERVAL = 3000;
    const MAX_QUEUE_SIZE = 50;
    const MAX_TOTAL_PER_PAGE = 10;

    const queue = [];
    let timer = null;
    let totalSent = 0;

    const recentResources = new Set();
    const RESOURCE_DEDUP_MS = 60000;

    const recentPromiseErrors = new Set();
    const PROMISE_DEDUP_MS = 60000;

    let isPageUnloading = false;

    const OWN_DOMAINS = ['tenways.com', 'cdn.shopify.com', 'shopify.com'];

    function isOwnResource(url) {
        try {
            const host = new URL(url).hostname;
            return OWN_DOMAINS.some(function (d) {
                return host === d || host.endsWith('.' + d);
            });
        } catch (e) {
            return false;
        }
    }

    function isCartUrl(url) {
        if (!url || typeof url !== 'string') return false;
        return url.includes('/cart');
    }

    function normalizeCartUrl(url) {
        try {
            var parsedUrl = new URL(url, location.origin);
            // 防缓存参数会让同一接口在监控中看起来像成千上万个不同错误，
            // 但这些参数无法用于区分错误原因。
            parsedUrl.searchParams.delete('_tmp');
            parsedUrl.searchParams.delete('_');
            return parsedUrl.pathname + parsedUrl.search;
        } catch (e) {
            return url.replace(/([?&])(?:_tmp|_)=[^&]*&?/g, '$1').replace(/[?&]$/, '');
        }
    }

    function isLoyaltyLionCartRead(method, normalizedUrl, requestStack) {
        return String(method).toUpperCase() === 'GET'
            && normalizedUrl === '/cart.js'
            && /sdk-static\.loyaltylion\.net/i.test(requestStack || '');
    }

    function flush() {
        if (!queue.length) return;
        const batch = queue.splice(0, queue.length);
        if (timer) { clearTimeout(timer); timer = null; }

        totalSent += batch.length;

        _fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ logs: batch }),
            keepalive: true
        }).catch(function () { });
    }

    function triggerSend() {
        if (queue.length >= BATCH_SIZE) {
            flush();
            return;
        }
        if (!timer) timer = setTimeout(flush, BATCH_INTERVAL);
    }

    function log(source, message, data) {
        if (totalSent + queue.length >= MAX_TOTAL_PER_PAGE) return;
        if (queue.length >= MAX_QUEUE_SIZE) return;

        queue.push({
            source: source,
            message: message,
            data: data,
            time: new Date().toISOString(),
            url: location.href,
            ua: ua
        });
        triggerSend();
    }

    // 全局 JS 错误监听 — 过滤无意义的跨域 "Script error."
    window.addEventListener('error', function (e) {
        if (e.target !== window) return;
        if (e.message === 'Script error.' && !e.filename) return;

        var msg = e.message || '';
        // Shopify 平台脚本加载失败，非业务代码可控
        if (/load error:.*\/shopifycloud\/|load error:.*\/web-pixels/i.test(msg)) return;
        // 浏览器/App 内置 WebView 注入的脚本错误，非业务代码可控
        if (/_AutofillCallbackHandler|_HandleMessageFromTitan|androidInterface|UCShellJava/i.test(msg)) return;

        log('GlobalError', msg, {
            file: e.filename,
            line: e.lineno,
            col: e.colno,
            stack: e.error && e.error.stack
        });
    });

    // 资源加载错误监听 — 只记录自有域名资源
    window.addEventListener('error', function (e) {
        var target = e.target;
        if (target === window || !target || !target.tagName) return;

        var tagName = target.tagName.toLowerCase();
        // 图片经常因懒加载、响应式图片切换、广告拦截或页面跳转取消而加载失败，
        // 因此不纳入错误监控。
        if (tagName === 'img') return;

        var resourceTags = ['script', 'link', 'video', 'audio', 'source', 'iframe'];
        if (!resourceTags.includes(tagName)) return;

        var resourceUrl = target.src || target.href || '';
        if (!resourceUrl) return;

        if (!isOwnResource(resourceUrl)) return;
        if (/\/web-pixels[@/]|\/web-pixel[-/]|\/shopifycloud\//.test(resourceUrl)) return;

        if (recentResources.has(resourceUrl)) return;
        recentResources.add(resourceUrl);
        setTimeout(function () { recentResources.delete(resourceUrl); }, RESOURCE_DEDUP_MS);

        var detail = {
            resourceUrl: resourceUrl,
            className: target.className || '',
            online: navigator.onLine
        };

        // 网络质量信息（移动端尤其有用）
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (conn) {
            detail.effectiveType = conn.effectiveType || '';
            detail.downlink = conn.downlink;
            detail.saveData = conn.saveData || false;
        }

        // 通过 Performance API 获取资源加载的 HTTP 状态等信息
        if (window.performance && performance.getEntriesByName) {
            var entries = performance.getEntriesByName(resourceUrl, 'resource');
            var entry = entries.length ? entries[entries.length - 1] : null;
            if (entry) {
                // 如果最近一次记录显示 200 且有传输数据，说明资源可用，本次 error 大概率是误报
                if (entry.responseStatus === 200 && entry.transferSize > 0) return;
                detail.responseStatus = entry.responseStatus;
                detail.transferSize = entry.transferSize;
                detail.duration = Math.round(entry.duration);
            }
        }

        log('ResourceError', tagName + ' load failed', detail);
    }, true);

    // 未处理的 Promise 异常 — 按 message 去重
    window.addEventListener('unhandledrejection', function (e) {
        var r = e.reason;
        var msg = r && r.message ? r.message : String(r);

        var dedupKey = msg.slice(0, 200);
        if (recentPromiseErrors.has(dedupKey)) return;
        recentPromiseErrors.add(dedupKey);
        setTimeout(function () { recentPromiseErrors.delete(dedupKey); }, PROMISE_DEDUP_MS);

        log('PromiseError', msg, {
            stack: r && r.stack,
            type: (r && r.name) || typeof r
        });
    });

    // fetch 拦截（仅购物车相关请求）
    try {
        window.fetch = function () {
            var args = arguments;
            try {
                var input = args[0];
                var init = args[1] || {};
                var url = '';
                var method = 'GET';

                if (typeof input === 'string') {
                    url = input;
                } else if (input && input.url) {
                    url = input.url;
                    method = input.method || method;
                }

                if (init.method) method = init.method;

                if (!isCartUrl(url)) return _fetch.apply(this, args);

                var requestStack = '';
                try { requestStack = new Error('Cart request initiated').stack; } catch (e) { }
                var promise = _fetch.apply(this, args);

                promise.then(function (res) {
                    try {
                        if (res.ok) return;
                        res.clone().json().then(function (data) {
                            log('CartAPI-HttpError', url, {
                                method: method,
                                status: res.status,
                                errors: data.errors || data.description || data.message,
                                requestStack: requestStack
                            });
                        }).catch(function () {
                            log('CartAPI-ParseError', url, {
                                method: method,
                                status: res.status,
                                requestStack: requestStack
                            });
                        });
                    } catch (e) { }
                }).catch(function (err) {
                    try {
                        var errorName = err && err.name;
                        var errorMessage = err && err.message;
                        // 页面跳转或进入后台时被拒绝的 fetch 属于浏览器取消请求，
                        // 不是 Shopify 购物车接口故障。
                        if (isPageUnloading || document.visibilityState === 'hidden') return;
                        if (errorName === 'AbortError') return;

                        var normalizedUrl = normalizeCartUrl(url);
                        // LoyaltyLion 会在后台读取 /cart.js；当 Safari 取消请求时，
                        // 可能连续重试多次。第三方错误，
                        // 不是用户购物车操作错误。
                        if (isLoyaltyLionCartRead(method, normalizedUrl, requestStack)) return;

                        log('CartAPI-NetworkError', normalizedUrl, {
                            method: method,
                            requestUrl: url,
                            error: errorMessage,
                            stack: err && err.stack,
                            requestStack: requestStack,
                            normalizedUrl: normalizedUrl,
                            online: navigator.onLine,
                            visibilityState: document.visibilityState
                        });
                    } catch (e) { }
                });

                return promise;
            } catch (e) {
                return _fetch.apply(this, args);
            }
        };
    } catch (e) { }

    window.reportCartError = function (source, message, errorOrData) {
        var data = {};

        if (errorOrData instanceof Error) {
            data = {
                errorMessage: errorOrData.message,
                stack: errorOrData.stack
            };
        } else if (typeof errorOrData === 'string') {
            data = { errorMessage: errorOrData };
        } else if (errorOrData && typeof errorOrData === 'object') {
            data = errorOrData;
        }

        log(source, message, data);
    };

    window.addEventListener('pagehide', function () {
        isPageUnloading = true;
    });
    window.addEventListener('beforeunload', function () {
        isPageUnloading = true;
        flush();
    });
})();
